

import { rei } from "@/services/api"

export default class ErrorService {
  static onError (err, vm, info) {
    const { response, message } = err

    if (!response) {
      const payload  = {
        message: message ? message : err,
        url: window.location.pathname,
        component: vm.$options._componentTag || vm.$vnode.tag,
        info: info,
        origem: 'REI_CLIENT'
      }

      rei.post(`report`, { ...payload }).then(res => res.data)
    }
    
    console.error(err)
  }
}